jQuery(function ($) {
  // ヘッダー
  // var headerHeight = $('#header').outerHeight();
  // $('body').css('padding-top', headerHeight + 'px');
  $(window).on("scroll", function () {
    const sliderHeight = 10;
    if (sliderHeight < $(this).scrollTop()) {
      $("#header").addClass("is-fixed");
    } else {
      $("#header").removeClass("is-fixed");
    }
  });
});

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
  // var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

jQuery(function ($) {
  // お客様バナー
  if ($(".banner-slider").length > 0) {
    const bannerSlider = new Swiper(".banner-slider", {
      loop: true,
      slidesPerView: "auto",
      speed: 6000,
      spaceBetween: 40,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
    });
  }

  // ケーススライダー（768px以下でのみ有効）
  let caseSlider = null;

  function initCaseSlider() {
    if ($(".case-slider").length > 0) {
      // 既存のスライダーがある場合は破棄
      if (caseSlider) {
        caseSlider.destroy(true, true);
        caseSlider = null;
      }

      // 768px以下の場合のみスライダーを初期化
      if (window.innerWidth <= 768) {
        caseSlider = new Swiper(".case-slider", {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 25,
        });
      }
    }
  }

  // カラムスライダー（768px以下でのみ有効）
  let columnSlider = null;

  function initColumnSlider() {
    if ($(".column-slider").length > 0) {
      // 既存のスライダーがある場合は破棄
      if (columnSlider) {
        columnSlider.destroy(true, true);
        columnSlider = null;
      }

      // 768px以下の場合のみスライダーを初期化
      if (window.innerWidth <= 768) {
        columnSlider = new Swiper(".column-slider", {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 25,
        });
      }
    }
  }

  // 初期化
  initCaseSlider();
  initColumnSlider();

  // リサイズ時の判定
  $(window).on("resize", function () {
    initCaseSlider();
    initColumnSlider();
  });

  if ($(".feature-slider").length > 0) {
    const featureSlider = new Swiper(".feature-slider", {
			loop: true,
			slidesPerView: 'auto', 
			speed: 6000, 
			spaceBetween: 12,
			allowTouchMove: false, 
      autoplay: {
        delay: 0,
      },
    });
  }
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

jQuery(function ($) {
  //二重送信抑制
  let submitBtn = $("input[type='submit'].wpcf7-submit");
  submitBtn.click(function () {
    $(this).css("pointer-events", "none");
    $(this).css("opacity", "0.5");
  });
  // 入力項目にエラーがあったらボタン復活
  document.addEventListener(
    "wpcf7invalid",
    function () {
      submitBtn.css("pointer-events", "auto");
      submitBtn.css("opacity", "1");
    },
    false
  );
});

jQuery(function ($) {
  $('.js-interview-more').click(function () {
    $(this).toggleClass('is-open');
    $(this).parent('.p-recruit__interview__block').find('.p-recruit__interview__contents').fadeToggle(0);
  });
  
});



jQuery(function ($) {
  // タブクリック時の処理
  $('.js-job-tab').on('click', function() {
    
    // クリックされたタブのインデックスを取得
    var clickedIndex = $('.js-job-tab').index(this);
    
    // 全てのタブから active クラスを削除
    $('.js-job-tab').removeClass('is-active');
    
    // 全てのコンテンツから active クラスを削除
    $('.js-job-contents').removeClass('is-active');
    
    // クリックされたタブに active クラスを追加
    $(this).addClass('is-active');
    
    // 対応するコンテンツに active クラスを追加
    $('.js-job-contents').eq(clickedIndex).addClass('is-active');
  });
});

// スクロールヒント
jQuery(function ($) {
  if ($(".js-scroll").length > 0) {
    new ScrollHint(".js-scroll");
  }
});


// Contact Form 7 ラジオボタンのURLパラメーター連携
jQuery(function($) {
	// ラジオボタンを選択する関数
	function selectRadioByParam() {
		// /contact/ページでのみ実行
		if ($('.p-contact').length > 0 && $('.p-form__radio').length > 0) {
			// URLパラメーターを取得
			var urlParams = new URLSearchParams(window.location.search);
			var typeParam = urlParams.get('type');
			
			// ラジオボタンのリストを取得
			var $radioItems = $('.p-form__radio').find('input[type="radio"]');
			
			if ($radioItems.length >= 3) {
				var targetIndex = -1;
				
				// パラメーターに応じて選択するインデックスを決定
				if (typeParam === 'download') {
					targetIndex = 1;
				}
				// 対応するラジオボタンを選択
				if (targetIndex >= 0 && targetIndex < $radioItems.length) {
					$radioItems.eq(targetIndex).prop('checked', true).trigger('change');
				}
			}
		}
	}
	
	// ページ読み込み時に実行
	selectRadioByParam();
	
	// Contact Form 7がAJAXで読み込まれた場合にも対応
	$(document).on('wpcf7mailsent wpcf7invalid wpcf7spam wpcf7mailfailed wpcf7submit', function() {
		// フォーム送信後、リセットされた場合に再実行
		setTimeout(selectRadioByParam, 100);
	});
	
	// Contact Form 7のフォームが読み込まれた時にも実行
	$(document).on('DOMContentLoaded', selectRadioByParam);
	
	// 少し遅延して実行（フォームが完全に読み込まれるまで待つ）
	setTimeout(selectRadioByParam, 500);
});
